import type { FC } from "react";

import type { Size } from "@/assets/icons/utils";
import type { PropsWithClassName } from "@/components/podkit/lib/cn";

export const AppleLogo: FC<{ size: Size } & PropsWithClassName> = ({ size, className }) => {
    switch (size) {
        case "sm":
            return (
                <svg width="16" height="16" viewBox="0 0 16 16" fill="none" xmlns="http://www.w3.org/2000/svg">
                    <g clipPath="url(#clip0_2_2766)">
                        <path
                            d="M11.8135 8.4236C11.8331 10.5382 13.6686 11.2419 13.6889 11.2509C13.6734 11.3005 13.3956 12.2537 12.7219 13.2383C12.1395 14.0895 11.535 14.9376 10.5828 14.9552C9.6472 14.9724 9.34634 14.4003 8.27665 14.4003C7.20728 14.4003 6.87302 14.9376 5.98734 14.9724C5.06822 15.0072 4.36833 14.0519 3.78109 13.2038C2.58112 11.469 1.66411 8.30161 2.89543 6.16358C3.50713 5.10182 4.60027 4.42947 5.78678 4.41223C6.68933 4.39501 7.54123 5.01943 8.09297 5.01943C8.64435 5.01943 9.67959 4.26851 10.7679 4.37879C11.2235 4.39776 12.5024 4.56283 13.3236 5.76486C13.2574 5.80588 11.7976 6.6557 11.8135 8.4236ZM10.0551 3.23105C10.543 2.64039 10.8715 1.81814 10.7819 1C10.0785 1.02827 9.22798 1.4687 8.72347 2.05904C8.27134 2.58181 7.87537 3.41853 7.98221 4.22048C8.76619 4.28114 9.56709 3.82209 10.0551 3.23105Z"
                            fill="currentColor"
                        />
                    </g>
                    <defs>
                        <clipPath id="clip0_2_2766">
                            <rect width="11.3778" height="14" fill="white" transform="translate(2.31111 1)" />
                        </clipPath>
                    </defs>
                </svg>
            );
        case "base":
            return (
                <svg
                    className={className}
                    width="20"
                    height="20"
                    viewBox="0 0 20 20"
                    fill="none"
                    xmlns="http://www.w3.org/2000/svg"
                >
                    <g clipPath="url(#clip0_2_2770)">
                        <path
                            d="M14.3583 10.4841C14.3807 12.9008 16.4783 13.705 16.5016 13.7153C16.4839 13.772 16.1664 14.8614 15.3965 15.9866C14.7308 16.9594 14.04 17.9287 12.9518 17.9488C11.8825 17.9685 11.5387 17.3147 10.3162 17.3147C9.09404 17.3147 8.71202 17.9287 7.69982 17.9685C6.6494 18.0082 5.84952 16.9165 5.17838 15.9472C3.807 13.9646 2.75898 10.3447 4.16621 7.90123C4.86529 6.68779 6.1146 5.91939 7.47061 5.89969C8.50209 5.88001 9.47569 6.59363 10.1062 6.59363C10.7364 6.59363 11.9195 5.73544 13.1633 5.86148C13.684 5.88315 15.1456 6.07181 16.0841 7.44556C16.0085 7.49244 14.3401 8.46366 14.3583 10.4841ZM12.3487 4.54978C12.9063 3.87473 13.2817 2.93501 13.1793 2C12.3754 2.03231 11.4034 2.53566 10.8268 3.21033C10.3101 3.80778 9.85756 4.76404 9.97967 5.68055C10.8756 5.74987 11.791 5.22524 12.3487 4.54978Z"
                            fill="currentColor"
                        />
                    </g>
                    <defs>
                        <clipPath id="clip0_2_2770">
                            <rect width="13.0032" height="16" fill="white" transform="translate(3.49841 2)" />
                        </clipPath>
                    </defs>
                </svg>
            );
        case "lg":
            return (
                <svg width="24" height="24" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
                    <g clipPath="url(#clip0_2_2774)">
                        <path
                            d="M16.9031 12.5446C16.9283 15.2634 19.2882 16.1681 19.3143 16.1797C19.2943 16.2435 18.9372 17.469 18.071 18.7349C17.3222 19.8294 16.5451 20.9198 15.3208 20.9424C14.1178 20.9645 13.731 20.229 12.3557 20.229C10.9808 20.229 10.551 20.9198 9.41231 20.9645C8.23059 21.0093 7.33072 19.7811 6.5757 18.6906C5.03289 16.4601 3.85387 12.3878 5.437 9.63888C6.22346 8.27377 7.62894 7.40932 9.15445 7.38715C10.3149 7.36501 11.4102 8.16784 12.1195 8.16784C12.8285 8.16784 14.1595 7.20237 15.5587 7.34416C16.1445 7.36854 17.7888 7.58078 18.8446 9.12625C18.7595 9.17899 16.8827 10.2716 16.9031 12.5446ZM14.6423 5.8685C15.2696 5.10908 15.6919 4.05189 15.5767 3C14.6724 3.03635 13.5788 3.60262 12.9302 4.36162C12.3489 5.03375 11.8398 6.10954 11.9771 7.14062C12.9851 7.2186 14.0148 6.6284 14.6423 5.8685Z"
                            fill="currentColor"
                        />
                    </g>
                    <defs>
                        <clipPath id="clip0_2_2774">
                            <rect width="14.6286" height="18" fill="white" transform="translate(4.68573 3)" />
                        </clipPath>
                    </defs>
                </svg>
            );
    }
};
